var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 2.25C2.58579 2.25 2.25 2.58579 2.25 3V10C2.25 10.4142 2.58579 10.75 3 10.75H10C10.4142 10.75 10.75 10.4142 10.75 10V3C10.75 2.58579 10.4142 2.25 10 2.25H3ZM3.75 9.25V3.75H9.25V9.25H3.75ZM14 2.25C13.5858 2.25 13.25 2.58579 13.25 3V10C13.25 10.4142 13.5858 10.75 14 10.75H21C21.4142 10.75 21.75 10.4142 21.75 10V3C21.75 2.58579 21.4142 2.25 21 2.25H14ZM14.75 9.25V3.75H20.25V9.25H14.75ZM13.25 14C13.25 13.5858 13.5858 13.25 14 13.25H21C21.4142 13.25 21.75 13.5858 21.75 14V21C21.75 21.4142 21.4142 21.75 21 21.75H14C13.5858 21.75 13.25 21.4142 13.25 21V14ZM14.75 14.75V20.25H20.25V14.75H14.75ZM3 13.25C2.58579 13.25 2.25 13.5858 2.25 14V21C2.25 21.4142 2.58579 21.75 3 21.75H10C10.4142 21.75 10.75 21.4142 10.75 21V14C10.75 13.5858 10.4142 13.25 10 13.25H3ZM3.75 20.25V14.75H9.25V20.25H3.75Z",
    fill: "#414141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.482aa559ea7a6bb769daca7c6f103993.svg";
export { ForwardRef as ReactComponent };